import React, {useEffect, useState} from 'react';
import {Button} from 'adminlte-2-react';
import {
  log,
  responseSelector,
  prepareDatosAuxOptions,
  constants,
} from '../utils/utils';
import {SelectInput} from '../utils/SelectInput';
import Etiqueta from '../utils/etiquetaObligatorio/Etiqueta';
import {CheckBox} from '../ui/Checkbox';
import {MonedaInputV2} from '../ui/moneda';
import {Alert, alertTypes} from '../ui/alert';
import {CargosPotencialesNotas} from './editar/CargosPotencialesNotas';
import {useDispatch, useSelector} from 'react-redux';
import {
  crearCargoPotDuck,
  crearCargoPotThunk,
  crearNotaDuck,
  crearNotaThunk,
  getCargosPotDuck,
  getCargosPotThunk,
  updateNotaDuck,
  updateNotaThunk,
} from './duck';
import {
  getCargosDuck,
  getCargosThunk,
  getUsuariosForSelectDuck,
  getUsuariosForSelectThunk,
} from '../oportunidades/duck';
import {AgregarExperienciaView} from './AgregarExperienciaView';
import {equiposOptionsGetDuck, equiposOptionsGetThunk} from '../equipos/duck';
const {TextInput} = require('../utils/TextInput');

function EditarNotaView({
  notaSelected,
  setNotaSelected,
  cargoPotSubmitAlert,
  setShowInputs,
  token,
  candidatoIdNumerico,
  oportunidadId,
  handlePageNotas,
  handlePage,
  setTopAlert,
}) {
  const dispatch = useDispatch();
  const modelUsuarios = useSelector(state => state.getUsuariosForSelect);
  const modelCrearNota = useSelector(state => state.crearNota);
  const modelUpdateNota = useSelector(state => state.updateNota);
  const modelGetCargosPot = useSelector(state => state.getCargosPot);
  const modelCrearCargoPot = useSelector(state => state.crearCargoPot);
  const modelGetCargos = useSelector(state => state.getCargos);
  const modelEquipos = useSelector(state => state.equiposOptions);
  const [cargosOptions, setCargosOptions] = useState([]);

  const [equipoOptions, setEquipoOptions] = useState([]);
  const [equipo, setEquipo] = useState();

  const [cargoOption, setCargoOption] = useState();
  const [usuarioOptions, setUsuarioOptions] = useState([]);
  const [usuarioSelected, setUsuarioSelected] = useState({});
  const [cargosPotenciales, setCargosPotenciales] = useState([]);

  const [expectativaSalarial, setExpectativaSalarial] = useState('0');

  const [titulo, setTitulo] = useState('');

  const [contenido, setContenido] = useState('');
  const [cuentaFiltroChecked, setCuentaFiltroChecked] = useState(true);
  const [conSupervision, setConSupervision] = useState(false);

  const [tieneExperiencia, setTieneExperiencia] = useState(true);

  useEffect(() => {
    if (notaSelected) {
      setTitulo(notaSelected.titulo);
      setContenido(notaSelected.contenido);
      setCuentaFiltroChecked(notaSelected.cuentaFiltro);
    }
  }, [notaSelected]);

  function submitNota() {
    setTopAlert({
      title: null,
      text: null,
      type: null,
      closable: false,
    });
    if (cargosPotenciales.length < 3) {
      setTopAlert({
        text: 'El candidato debe tener al menos 3 cargos potenciales para crear la nota',
        type: alertTypes.danger,
        closable: false,
      });
      return;
    }

    if (!titulo || !contenido) {
      setTopAlert({
        text: 'La nota debe incluir titulo y contenido',
        type: alertTypes.danger,
        closable: false,
      });
      return;
    }

    if (!oportunidadId && !equipo?.value && cuentaFiltroChecked) {
      setTopAlert({
        text: 'Debe seleccionar un equipo',
        type: alertTypes.danger,
        closable: false,
      });
      return;
    }

    if (conSupervision && !usuarioSelected?.value) {
      setTopAlert({
        text: 'Debe seleccionar un usuario',
        type: alertTypes.danger,
        closable: false,
      });
      return;
    }

    if (!notaSelected) {
      dispatch(
        crearNotaThunk({
          userToken: token.raw,
          titulo,
          contenido,
          candidatoIdNumerico,
          oportunidadId,
          expectativaSalarial,
          cuentaFiltro: cuentaFiltroChecked,
          companheroId:
            conSupervision && usuarioSelected?.value
              ? usuarioSelected?.value
              : null,
          equipoId: equipo?.value,
        }),
      );
    } else {
      dispatch(
        updateNotaThunk({
          userToken: token.raw,
          titulo,
          contenido,
          candidatoIdNumerico,
          idNumerico: notaSelected.idNumerico,
          creacionUsuario: notaSelected.creacionUsuario,
          expectativaSalarial,
          cuentaFiltro: cuentaFiltroChecked,
          companheroId:
            conSupervision && usuarioSelected?.value
              ? usuarioSelected?.value
              : null,
          equipoId: equipo?.value,
        }),
      );
    }
  }

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelCrearNota);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      dispatch(crearNotaDuck.actions.clear());
    }

    if (data) {
      setTitulo('');
      setContenido('');
      setUsuarioSelected({});
      setConSupervision(false);
      setShowInputs(false);
      handlePageNotas(0);
      if (handlePage) {
        handlePage(0);
      }

      setTopAlert({
        text: 'Nota creada correctamente',
        type: alertTypes.success,
        closable: false,
      });

      dispatch(crearNotaDuck.actions.clear());
    }
  }, [modelCrearNota]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelUpdateNota);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      if (handlePage) {
        handlePage(0);
      }
      dispatch(updateNotaDuck.actions.clear());
    }
    if (data) {
      setTitulo('');
      setContenido('');
      setUsuarioSelected({});
      setConSupervision(false);
      setNotaSelected(null);
      setShowInputs(false);
      handlePageNotas(0);
      if (handlePage) {
        handlePage(0);
      }
      setTopAlert({
        text: 'Nota actualizada correctamente',
        type: alertTypes.success,
        closable: false,
      });

      dispatch(updateNotaDuck.actions.clear());
    }
  }, [modelUpdateNota]);

  function agregarCargoPot() {
    const data = {
      userToken: token.raw,
      candidatoIdNumerico: candidatoIdNumerico,
      cargoIdNumerico: cargoOption?.value,
    };

    log({'agregarCargoPot.data': data});

    dispatch(crearCargoPotThunk(data));
  }

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelUsuarios);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getUsuariosForSelectDuck.actions.clear());
    }

    if (data) {
      setUsuarioOptions(data?.data);

      if (notaSelected.companheroId) {
        const usuarioSupervision = data?.data.find(
          elem => elem.value === notaSelected.companheroId,
        );
        setUsuarioSelected(usuarioSupervision);
        setConSupervision(true);
      }
      dispatch(getUsuariosForSelectDuck.actions.clear());
    }
  }, [modelUsuarios]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelEquipos);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(equiposOptionsGetDuck.actions.clear());
    }

    if (data) {
      setEquipoOptions(data);

      if (notaSelected.equipoId) {
        const equipoSelected = data.find(
          elem => elem.value === notaSelected.equipoId,
        );
        setEquipo(equipoSelected);
        setCuentaFiltroChecked(true);
      }
      dispatch(equiposOptionsGetDuck.actions.clear());
    }
  }, [modelEquipos]);

  useEffect(() => {
    dispatch(
      equiposOptionsGetThunk({
        userToken: token.raw,
      }),
    );
    dispatch(
      getCargosThunk({
        userToken: token.raw,
      }),
    );
    dispatch(
      getCargosPotThunk({
        userToken: token.raw,
        candidatoIdNumerico: candidatoIdNumerico,
      }),
    );

    dispatch(
      getUsuariosForSelectThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetCargos);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCargosDuck.actions.clear());
    }

    if (data) {
      const cargos = data.items;

      const datosAuxOptions = prepareDatosAuxOptions(cargos);

      setCargosOptions(datosAuxOptions);

      dispatch(getCargosDuck.actions.clear());
    }
  }, [modelGetCargos]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetCargosPot);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCargosPotDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      // log({ 'getCargosPot.data': data });

      dispatch(getCargosPotDuck.actions.clear());
      setExpectativaSalarial(data.expectativaSalarial);
      setCargosPotenciales(data.cargosPotenciales);
      setTieneExperiencia(data.tieneExperiencias);
    }
  }, [modelGetCargosPot]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelCrearCargoPot);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(crearCargoPotDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(crearCargoPotDuck.actions.clear());

      dispatch(
        getCargosPotThunk({
          userToken: token.raw,
          candidatoIdNumerico: candidatoIdNumerico,
        }),
      );
      setTopAlert({
        text: 'Cargo potencial agregado correctamente',
        type: alertTypes.success,
        closable: false,
      });
    }
  }, [modelCrearCargoPot]);

  function onErrorExperiencia(msg) {
    setTopAlert({
      text: msg,
      type: alertTypes.danger,
      closable: false,
    });
  }

  function onSuccessExperiencia() {
    setTieneExperiencia(true);
    if (handlePage) {
      handlePage(0);
    }
  }

  return (
    <>
      <div className="form-group">
        {!tieneExperiencia && (
          <AgregarExperienciaView
            token={token}
            candidatoIdNumerico={candidatoIdNumerico}
            onError={onErrorExperiencia}
            onSuccess={onSuccessExperiencia}
          />
        )}

        {tieneExperiencia && (
          <>
            <Alert
              title="Observacion"
              type={alertTypes.info}
              text="El candidato debe tener al menos 3 cargos potenciales para crear una nota"
              closable={false}
            />

            <h4>Cargos potenciales</h4>

            <h5>
              Para editar o eliminar cargo potenciales acceder a la pantalla de{' '}
              <a
                href={`/editarCandidato/${candidatoIdNumerico}`}
                target="_blank"
                rel="noreferrer">
                edicion del usuario
              </a>
            </h5>

            <CargosPotencialesNotas
              agregarCargoPot={agregarCargoPot}
              cargoOption={cargoOption}
              setCargoOption={setCargoOption}
              cargosOptions={cargosOptions}
              modelCrearCargoPot={modelCrearCargoPot}
              cargoPotSubmitAlert={cargoPotSubmitAlert}
              modelGetCargosPot={modelGetCargosPot}
              cargosPotenciales={cargosPotenciales}
            />

            <h4>Expectativa salarial</h4>

            <MonedaInputV2
              initialValue={expectativaSalarial}
              setValue={setExpectativaSalarial}
              selectorMonedaDisabled={true}
            />

            <h4>Nota</h4>

            <TextInput
              label="Título"
              initialValue={titulo}
              setValue={setTitulo}
            />

            <label>
              <Etiqueta texto="Observación" obligatorio={false} />
            </label>

            <textarea
              className="form-control"
              rows="5"
              value={contenido}
              onChange={evt => setContenido(evt.target.value)}
            />

            <br />
            {conSupervision && (
              <SelectInput
                label="Usuario"
                value={usuarioSelected}
                options={usuarioOptions}
                setValue={setUsuarioSelected}
                required
              />
            )}
            {oportunidadId && (
              <CheckBox
                text="Con supervision"
                checked={conSupervision}
                onChange={setConSupervision}
              />
            )}

            {!oportunidadId && cuentaFiltroChecked ? (
              <SelectInput
                label="Equipo"
                value={equipo}
                options={equipoOptions}
                setValue={setEquipo}
                required
              />
            ) : null}

            <CheckBox
              text="Cuenta como producción"
              checked={cuentaFiltroChecked}
              onChange={setCuentaFiltroChecked}
            />

            <Button
              pullRight
              type="primary"
              text="Guardar"
              disabled={
                (notaSelected &&
                  !notaSelected.destacado &&
                  cargosPotenciales.length < 3) ||
                (!notaSelected && cargosPotenciales.length < 3)
              }
              margin
              size="sm"
              onClick={() => {
                submitNota();
              }}
            />

            <Button
              pullRight
              type="danger"
              text="Cancelar"
              size="sm"
              margin
              onClick={() => {
                setNotaSelected(null);
                setTitulo('');
                setContenido('');
                setUsuarioSelected({});
                setConSupervision(false);
                setShowInputs(false);
              }}
            />

            <br />
          </>
        )}
      </div>
    </>
  );
}

export {EditarNotaView};
